/**
 * SOAP Notes API Service
 * Handles all SOAP note-related API calls
 */

import { post, get, del, put, postFormData } from './client';

export const soapApi = {
  /**
   * Generate SOAP note from audio
   * @param {FormData} formData - Audio file form data
   * @param {AbortSignal} [signal] - Optional abort signal for cancellation
   */
  generateFromAudio: async (formData, signal) => {
    return postFormData('/api/transcription/transcribe', formData, signal);
  },

  /**
   * Get SOAP note history
   */
  getHistory: async (limit = 100, offset = 0) => {
    return get(`/api/soap/history?limit=${limit}&offset=${offset}`);
  },

  /**
   * Get single SOAP note by ID
   */
  getById: async (noteId) => {
    return get(`/api/soap/${noteId}`);
  },

  /**
   * Save SOAP note
   */
  save: async (soapNoteData) => {
    return post('/api/soap/save', soapNoteData);
  },

  /**
   * Delete SOAP note
   */
  delete: async (noteId) => {
    return del(`/api/soap/${noteId}`);
  },

  /**
   * Update SOAP note
   */
  update: async (noteId, updates) => {
    return put(`/api/soap/${noteId}`, updates);
  },

  /**
   * Generate AI clinical decision support
   */
  generateClinicalSupport: async (soapNote) => {
    return post('/api/ai/clinical-support', { soap_note: soapNote });
  },
};
